import {mapGetters, mapMutations, mapActions} from "vuex";
import vueMaskedInput from 'vue-masked-input'
import {required, minLength, email} from 'vuelidate/lib/validators'

export default {
    name: 'login',
    components: {
        vueMaskedInput,
    },
    data() {
        return {
            payload: {
                email: '',
                password: ''
            },
            submitted: false,
            authorizationError: false,
        }
    },
    validations: {
        payload: {
            email: {required, email},
            password: {required, minLength: minLength(8)},
        }
    },
    methods: {
        ...mapMutations({
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
            changeShowPopUpRegister: 'auth/CHANGE_POPUP_REGISTER',
            changeShowPopUpPasswordRecovery: 'auth/CHANGE_POPUP_PASSWORD_RECOVERY'
        }),
        ...mapActions({
            login: 'auth/LOGIN'
        }),

        register() {
            this.changeShowPopUpRegister(true)
            this.changeShowPopUpLogin(false)

        },
        forgotPassword() {
            this.changeShowPopUpPasswordRecovery(true)
            this.changeShowPopUpLogin(false)
        },
        loginUser() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                this.login(this.payload).then(() => {
                    this.changeShowPopUpLogin(false)

                    this.$router.push({name: 'userInfo'}).catch(
                        console.log('')
                    )
                }).catch(error => {
                    console.log(error)
                    if (error.status === 418) {
                        this.authorizationError = true
                    }
                })
            }

        },
    },
    computed: {
        ...mapGetters({
            showPopUpLogin: `auth/showPopUpLogin`,
            showPopUpPasswordRecovery: `auth/showPopUpPasswordRecovery`,
            getCurrentOrder: 'order/getCurrentOrder',
            isAuthenticated: 'auth/isAuthenticated',
            loginData: 'auth/loginData',
            loadingLogin: 'auth/loadingLogin'
        }),
    }
}
